import { useQuery } from '@tanstack/react-query';
import { documentService } from 'domain/documents/api/documentService';

export const recentDocumentsQueryKey = 'recentDocuments';

export default function useGetRecentDocuments() {
  return useQuery({
    queryKey: [recentDocumentsQueryKey],
    queryFn: documentService.getRecents,
  });
}
